import React from 'react';
import { CartButton } from './CartButton';
export function Header() {
  return <header className="w-full bg-white border-b border-gray-200 sticky top-0 z-30" data-id="element-101">
      <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between" data-id="element-102">
        {/* Logo */}
        <div className="flex items-center" data-id="element-103">
          <img src="https://cdn.magicpatterns.com/uploads/osz2cZss3C1hyH5p9n7d8q/ChatGPT_Image_Feb_23,_2026,_04_39_22_PM.png" alt="CrownControl™" className="h-24 md:h-28 w-auto" data-id="element-104" />
        </div>

        {/* Cart Button */}
        <CartButton data-id="element-105" />
      </div>
    </header>;
}